import { Supplies, Pagination, Common } from '@factorin/domain';

import { withUrl, list, patch } from '../rest';


interface SupplyListRequest extends Pagination.Request {
    registerUid?: string;
    baseDateRange?: Common.DateRange;
    providerUid?: string;
    providerINN?: string;
    buyerUid?: string;
    buyerINN?: string;
    supplyAgreementNumber?: string;
    primaryDocumentDateRange?: Common.DateRange;
    amount?: Common.DecimalRange;
    cessionAmount?: Common.DecimalRange;
}

export interface SupplyConfirmReject {
    registerUid: string;
    supplyUids: string[];
    confirm: boolean;
    reasonUid?: string;
    comment?: string;
}

const suppliesPart = withUrl('supplies');
export const supplies = {
    ...list<Supplies.Supply, SupplyListRequest>(suppliesPart()),

    confirm: patch<SupplyConfirmReject, void>(
        ({ registerUid, supplyUids, reasonUid, confirm, comment = '' }) => suppliesPart({
            query: {
                registerUid,
            },
            body: {
                Confirm: confirm,
                ReasonUid: reasonUid,
                Comment: comment,
                SupplyUids: supplyUids,
            },
        }),
    ),
};
